import { io } from 'socket.io-client';

class SocketService {
    constructor() {
        this.socket = null;
        this.isConnected = false;
    }

    connect() {
        if (this.socket && this.isConnected) {
            return this.socket;
        }

        const serverUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000';

        this.socket = io(serverUrl, {
            transports: ['websocket', 'polling'],
            timeout: 20000,
            forceNew: true
        });

        this.socket.on('connect', () => {
            console.log('Connected to server:', this.socket.id);
            this.isConnected = true;
        });

        this.socket.on('disconnect', (reason) => {
            console.log('Disconnected from server:', reason);
            this.isConnected = false;
        });

        this.socket.on('connect_error', (error) => {
            console.error('Connection error:', error);
            this.isConnected = false;
        });

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.isConnected = false;
        }
    }

    // Order events
    onNewOrder(callback) {
        if (this.socket) {
            this.socket.on('newOrder', callback);
        }
    }

    offNewOrder(callback) {
        if (this.socket) {
            this.socket.off('newOrder', callback);
        }
    }

    // Product events
    onProductAdded(callback) {
        if (this.socket) {
            this.socket.on('productAdded', callback);
        }
    }

    onProductUpdated(callback) {
        if (this.socket) {
            this.socket.on('productUpdated', callback);
        }
    }

    onProductStatusChanged(callback) {
        if (this.socket) {
            this.socket.on('productStatusChanged', callback);
        }
    }

    offProductAdded(callback) {
        if (this.socket) {
            this.socket.off('productAdded', callback);
        }
    }

    offProductUpdated(callback) {
        if (this.socket) {
            this.socket.off('productUpdated', callback);
        }
    }

    offProductStatusChanged(callback) {
        if (this.socket) {
            this.socket.off('productStatusChanged', callback);
        }
    }

    // Settings events
    onSettingUpdated(callback) {
        if (this.socket) {
            this.socket.on('settingUpdated', callback);
        }
    }

    onSettingDeleted(callback) {
        if (this.socket) {
            this.socket.on('settingDeleted', callback);
        }
    }

    offSettingUpdated(callback) {
        if (this.socket) {
            this.socket.off('settingUpdated', callback);
        }
    }

    offSettingDeleted(callback) {
        if (this.socket) {
            this.socket.off('settingDeleted', callback);
        }
    }

    // Generic event listeners
    on(event, callback) {
        if (this.socket) {
            this.socket.on(event, callback);
        }
    }

    off(event, callback) {
        if (this.socket) {
            this.socket.off(event, callback);
        }
    }

    emit(event, data) {
        if (this.socket && this.isConnected) {
            this.socket.emit(event, data);
        }
    }
}

// Create a singleton instance
const socketService = new SocketService();

export default socketService;